import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_BASE_URL } from '../constants/api'

const authRepository = createApi({
	reducerPath: 'authRepository',
	baseQuery: fetchBaseQuery({
		baseUrl: API_BASE_URL,
	}),
	endpoints: builder => ({
		signIn: builder.mutation<void, void>({
			query: userCredentials => ({
				url: '/login',
				method: 'POST',
				body: userCredentials,
			}),
		}),
		verify: builder.mutation<
			{
				id: number
				email: string
				ultimo_acesso: string
				permissao_id: number
				turma_id: number
				empresa_id: number
				nome: string
				googleId: string
				proficiencia_id: number
				createdAt: string
				updatedAt: string
				is_manager: boolean
				gestor: string
				primeiros_passos: number
			},
			{
				email: string
			}
		>({
			query: ({ email }) => ({
				url: '/v1/auth/student',
				params: {
					email,
				},
				method: 'GET',
				responseHandler: 'content-type',
			}),
		}),
	}),
})

export default authRepository
